import React from "react";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CreditCard from "@material-ui/icons/CreditCard";
import TextField from "@material-ui/core/TextField";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import { useDispatch } from "react-redux";
import { completeOrder } from "../../../app/shirtSlice";
const useStyles = makeStyles(({ palette }) => ({
  shippingRoot: {
    display: "flex",
    flexDirection: "column",
    background: "linear-gradient(45deg, #fafafa, #ffffff)",
    borderRadius: 12,
    height: "100%",
    overflow: "auto",
    "& *": {
      color: "#000000",
    },
  },
  root: {
    display: "flex",
    flexDirection: "column",
    background: "linear-gradient(45deg, #191D29, #3c5981)",
    borderRadius: 12,
    height: "100%",
    overflow: "auto",
    "& *": {
      color: "#fff",
    },
  },
  heading: {
    fontWeight: 900,
    fontSize: "2.25rem",
  },
  divider: {
    backgroundColor: "#fff",
    opacity: 0.12,
    margin: "24px 0",
  },
  shippingDivider: {
    opacity: 0.55,
    margin: "24px 0",
  },
  label: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 16,
    opacity: 0.87,
  },
  button: {
    minHeight: 48,
    borderRadius: 40,
    borderColor: "rgba(255, 255, 255, 0.12)",
    borderStyle: "solid",
    borderWidth: 1,
    width: "100%",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
    },
  },
  buttonActive: {
    borderColor: "#fff",
  },
  creditCardLabel: {
    fontSize: 12,
    textTransform: "initial",
  },
  paypalLabel: {
    fontSize: 20,
    textTransform: "initial",
    fontStyle: "italic",
    fontFamily:
      "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif",
    fontWeight: "bold",
    lineHeight: 1,
  },
  textField: {
    "& label": {
      opacity: 0.87,
      fontWeight: "bold",
    },
    "&:hover": {
      "& $inputBase:before": {
        borderColor: "rgba(255, 255, 255, 0.38)",
      },
    },
  },
  inputBase: {
    "&:before": {
      borderColor: "rgba(255, 255, 255, 0.12)",
    },
  },
  input: {
    padding: "16px 0",
  },
  select: {
    "& label": {
      opacity: 0.4,
    },
    "&:hover": {
      "& $inputBase:before": {
        borderColor: "rgba(255, 255, 255, 0.38)",
      },
    },
  },
  checkoutBtn: {
    marginTop: "auto",
    borderRadius: 40,

    color: "black",
    width: "100%",
  },

  checkoutContained: {
    backgroundColor: "white",
    background: "white",
    color: "black",
    width: "100%",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
    },
  },
  btn: {
    width: "100%",

    borderRadius: 40,
    border: "1px solid",
    borderColor: palette.grey[400],
    "& > *": {
      fontWeight: "bold",
      textTransform: "none",
    },
    marginRight: 72,
  },
}));

const Shipping = ({ setMode, name, city, state, email, zipcode, phone }) => {
  const styles = useStyles();

  return (
    <Box className={styles.shippingRoot} py={1.5} px={3.5}>
      <Typography className={styles.heading} variant={"h1"}>
        Shipping.
      </Typography>
      <Divider className={styles.shippingDivider} />
      <TextField
        className={styles.textField}
        fullWidth
        InputProps={{
          classes: { root: styles.inputBase, input: styles.input },
        }}
        label={"Full Name"}
        value={name}
      />
      <Box height={24} css={{ flex: "none" }} />
      <TextField
        className={styles.textField}
        fullWidth
        InputProps={{
          classes: { root: styles.inputBase, input: styles.input },
        }}
        label={"Email Address"}
        value={email}
      />
      <Box height={24} css={{ flex: "none" }} />
      <TextField
        className={styles.textField}
        fullWidth
        InputProps={{
          classes: { root: styles.inputBase, input: styles.input },
        }}
        label={"Phone Number"}
        type="phone"
        value={phone}
      />

      <Box height={24} css={{ flex: "none" }} />
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Typography className={styles.label}>Shipping Address:</Typography>
          <Box mt={"-23px"}>
            <Grid container spacing={3} justify="space-between">
              <Grid item xs={6}>
                <TextField
                  className={styles.select}
                  fullWidth
                  InputProps={{
                    classes: { root: styles.inputBase },
                  }}
                  value={city}
                  label="City"
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  className={styles.select}
                  fullWidth
                  InputProps={{
                    classes: { root: styles.inputBase },
                  }}
                  value={state}
                  label={"State"}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  className={styles.select}
                  InputProps={{
                    classes: { root: styles.inputBase },
                  }}
                  value={zipcode}
                  label={"Zip Code"}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Box height={24} css={{ flex: "none" }} />
      <Box flexGrow={1} />
      <Button
        className={styles.btn}
        onClick={() => setMode("cart")}
        startIcon={<KeyboardArrowLeft />}
      >
        Go back to Cart
      </Button>
    </Box>
  );
};

const DailyCheckout = ({ setMode }) => {
  let dispatch = useDispatch();
  const orderInfo = {
    name: "Yung Drip",
    city: "Drip City",
    state: "TX",
    email: "dripshop@gmail.com",
    zipcode: "42011",
    phone: "(210) 333-3333",
  };
  const styles = useStyles();
  return (
    <Grid container spacing={1}>
      <Grid item xs={7}>
        {" "}
        <Shipping setMode={setMode} {...orderInfo} />
      </Grid>
      <Grid item xs={5}>
        <Box className={styles.root} py={1.5} px={3.5}>
          <Typography className={styles.heading} variant={"h1"}>
            Payment Info.
          </Typography>
          <Divider className={styles.divider} />
          <Typography className={styles.label}>Payment Method:</Typography>
          <Grid container spacing={2}>
            <Grid xs={6} item>
              <Button
                startIcon={<CreditCard />}
                classes={{
                  root: cx(styles.button, styles.buttonActive),
                  label: styles.creditCardLabel,
                }}
              >
                Credit Card
              </Button>
            </Grid>
            <Grid xs={6} item>
              <Button
                classes={{ root: styles.button, label: styles.paypalLabel }}
              >
                PayPal
              </Button>
            </Grid>
          </Grid>
          <Divider className={styles.divider} />
          <TextField
            className={styles.textField}
            fullWidth
            InputProps={{
              classes: { root: styles.inputBase, input: styles.input },
            }}
            label={"Name On Card:"}
            value={"Yung Lean"}
          />
          <Box height={24} css={{ flex: "none" }} />
          <TextField
            className={styles.textField}
            fullWidth
            InputProps={{
              classes: { root: styles.inputBase, input: styles.input },
            }}
            label={"Card Number:"}
            value={"••••  ••••  ••••  1829"}
          />
          <Box height={24} css={{ flex: "none" }} />
          <Grid container spacing={3}>
            <Grid item xs={8}>
              <Typography className={styles.label}>Expiration Date:</Typography>
              <Box mt={"-23px"}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      select
                      className={styles.select}
                      fullWidth
                      InputProps={{
                        classes: { root: styles.inputBase },
                      }}
                      label={"MM"}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      select
                      className={styles.select}
                      fullWidth
                      InputProps={{
                        classes: { root: styles.inputBase },
                      }}
                      label={"YYYY"}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <TextField
                className={styles.textField}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  classes: { root: styles.inputBase, input: styles.input },
                }}
                label={"CCV:"}
                placeholder={"XXX"}
              />
            </Grid>
          </Grid>
          <Box height={24} css={{ flex: "none" }} />
          <Button
            className={styles.btn}
            style={{ background: "rgba(0,0,0,0.3)" }}
            onClick={() => {
              setMode("success");
              dispatch(completeOrder(orderInfo));
            }}
            // color={"primary"}
          >
            Order
          </Button>
        </Box>
      </Grid>{" "}
    </Grid>
  );
};

export default DailyCheckout;
